// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"fe706277","252":"699fe67b","353":"6890ca29","906":"757fcf35","909":"a44fdc7e"}[chunkId] + ".chunk.css";
};